document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("shftPopup");

    if (!popup) return;

    const closeBtn = popup.querySelector(".shft-popup-close");
    const overlay = popup.querySelector(".shft-popup-overlay");

    function openPopup() {
        popup.classList.add("active");
        document.body.style.overflow = "hidden";
    }

    function closePopup() {
        popup.classList.remove("active");
        document.body.style.overflow = "";
    }

    // Popup kapatma
    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);

    document.addEventListener("keydown", function(e){
        if(e.key==="Escape"){
            closePopup();
        }
    });

    // TÜM ürün sayfası butonlarını yakala
    document.querySelectorAll(".product-form form").forEach(form=>{

        form.addEventListener("submit",function(e){

            e.preventDefault();

            e.stopImmediatePropagation();

            openPopup();

            return false;

        },true);

    });

});
document.addEventListener("click", function(e){

    const link = e.target.closest('a[href="#waitlist"]');

    if(!link) return;

    e.preventDefault();

    const popup = document.getElementById("shftPopup");

    if(popup){
        popup.classList.add("active");
        document.body.style.overflow = "hidden";
    }

});
document.addEventListener("click", async function(e){

    if(!e.target.classList.contains("shft-submit")) return;

    e.preventDefault();

    const emailInput=document.querySelector(".shft-email-input");

    const email=emailInput.value.trim();

    if(email===""){

        alert("Lütfen e-posta adresinizi girin.");

        return;

    }

    e.target.disabled=true;

    e.target.innerHTML="Kaydediliyor...";

    try {

    const formData = new FormData();

    formData.append("email", email);
    formData.append("page", window.location.href);

    const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzjI7PtTr8ivae5pDRfiG9jhXRH5RKHQp91nRJ5BNzkg-iaKDsu8wOPpglW9OEi9abt/exec",
        {
            method: "POST",
            body: formData
        }
    );

    if (!response.ok) {
        throw new Error("Sunucu hatası");
    }

    document.querySelector(".shft-form-area").innerHTML = `
        <div style="text-align:center;padding:30px 10px;">
            <div style="font-size:52px;">🎉</div>
            <h2>Yerin Ayrıldı</h2>
            <p>İlk satış başladığında sana haber vereceğiz.</p>
        </div>
    `;


    }catch(err){

        alert("Kayıt sırasında hata oluştu.");

        e.target.disabled=false;

        e.target.innerHTML="YERİMİ AYIR";

    }

});